package top.wcpe.allincore.ui.runtime.event

import kotlin.jvm.JvmName

/**
 * 拖拽放下事件：在某 dropTarget 上释放鼠标时触发。
 *
 * @property sourceId 发起拖拽的元素 id
 * @property targetId 接收放下的元素 id
 * @property payload 拖拽携带的数据（可为 null）
 * @property mouseX 释放鼠标 X（屏幕坐标）
 * @property mouseY 释放鼠标 Y
 */
data class DropEvent(
    // 保留 Java 记录式访问器 ABI：消费方以 `event.sourceId()` / `event.targetId()` 方法式调用
    @get:JvmName("sourceId") val sourceId: String,
    @get:JvmName("targetId") val targetId: String,
    @get:JvmName("payload") val payload: Any?,
    @get:JvmName("mouseX") val mouseX: Double,
    @get:JvmName("mouseY") val mouseY: Double,
)
